import { render, staticRenderFns } from "./prevGoods.vue?vue&type=template&id=3ae2088c&scoped=true&"
import script from "./prevGoods.vue?vue&type=script&lang=js&"
export * from "./prevGoods.vue?vue&type=script&lang=js&"
import style0 from "./prevGoods.vue?vue&type=style&index=0&id=3ae2088c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae2088c",
  null
  
)

export default component.exports